import { useFocusEffect } from 'expo-router';

import { useOtaMachine, useOtaMachineObserver } from '@sg/ota-installer';

import { useFeatureFlag, useLaunchDarkly } from '@order/LaunchDarkly';

import { useEssentialMachines } from '../../context/EssentialMachines';
import { useGlobalAppState } from '../../context/GlobalAppState';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Initializes an OTA update machine observer.
 */
export const useStartOtaObserver = () => {
  const { otaMachineRef } = useEssentialMachines();
  const { isLaunchDarklyReady, isLaunchDarklyTargetingContextSet } = useLaunchDarkly();
  const isOtaInstallerEnabled = useFeatureFlag('CELS-4466-order-in-app-ota-install-enabled');

  const isReady = isLaunchDarklyReady && isLaunchDarklyTargetingContextSet;

  // ─────────────────────────────────────────────────────────────────────

  useOtaMachineObserver({
    isReady,
    isEnabled: isOtaInstallerEnabled,
    actorRef: otaMachineRef,
  });
};

/**
 * Applies OTA update (if available) on screen focus.
 */
export const useOtaOnScreenFocus = () => {
  const { otaMachineRef } = useGlobalAppState();
  const { helpers } = useOtaMachine({ actorRef: otaMachineRef });

  useFocusEffect(helpers.applyUpdate);
};
